export default __webpack_public_path__ + "static/media/manual-download-crop.713b1d36.png";